// extracted by mini-css-extract-plugin
export default {"wrap":"TokenChips_wrap__RrDck","label":"TokenChips_label__GKQsT","chip":"TokenChips_chip__JeRbu"};